import { httpRetry } from '$core/helpers/http-retry';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { StaticStorage } from '../static-storage';
import { FooterDataDto } from '../types';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  private readonly http = inject(HttpClient);
  private readonly staticStorage = inject(StaticStorage);

  public getFooterStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/footer-data').pipe(
      httpRetry(5),
      tap((res: FooterDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }
}
